module.exports = __webpack_public_path__ + "img/1-2.3d0adfa5.jpeg";